<template>
  <v-main>
    <AppBar/>
    <v-container class="pt-0">
      <!-- 삼성 인 경우 -->
      <div v-if="isSamsungFire">
        <ul class="list-group ps-0">
          <li>
<!--            <router-link to="/fo/suitcase/TIC/tutorial">튜토리얼</router-link>-->
            <!-- 코치 마크 -->
            <a href="javascript: void(0)" @click="isShowCoachMark = !isShowCoachMark">튜토리얼</a>
          </li>
          <li>
            <router-link to="/fo/suitcase/TIC/FAQ">자주 묻는 질문</router-link>
          </li>
          <li @click="openSfKakao">
            1:1 고객 문의
          </li>
          <li @click="urgentConsultationOpen">
            긴급상담
          </li>
        </ul>
      </div>
      <div v-else>
        <ul class="list-group ps-0">
          <li>
<!--            <router-link to="/fo/suitcase/TIC/tutorial">튜토리얼</router-link>-->
            <a href="javascript: void(0)" @click="isShowCoachMark = !isShowCoachMark">튜토리얼</a>
          </li>
          <li>
            <router-link to="/fo/suitcase/TIC/notificationSettings">알림설정</router-link>
          </li>
          <li v-if="memberInfo.hmUseYn === 'Y'" @click="openHappymint()">
            해피민트 바로가기
          </li>
        </ul>
        <hr class="hr">
        <ul class="list-group ps-0">
          <li>
            <router-link to="/fo/suitcase/TIC/notic">공지사항</router-link>
          </li>
          <li>
            <router-link to="/fo/suitcase/TIC/FAQ">자주 묻는 질문</router-link>
          </li>
        </ul>
        <hr class="hr">
        <ul class="list-group ps-0">
          <li @click="termsDetailsOpen(0)">서비스 이용약관</li>

          <!-- 확인용 -->
<!--          <li @click="termsDetailsOpen(1)">개인정보 처리방침</li>-->
<!--          <li @click="termsDetailsOpen(2)">마케팅 수신 동의</li>-->
          <!-- //확인용 -->

          <li @click="termsDetailsOpen(3)">개인정보처리방침</li>

          <!-- 확인용 -->
<!--          <li @click="termsDetailsOpen(4)">개인정보 수집 동의</li>-->
<!--          <li @click="termsDetailsOpen(5)">개인정보 제공 동의</li>-->
          <!-- //확인용 -->

          <li class="no-arrow">버전명 V1.0.0</li>
          <li @click="logout" class="no-arrow">로그아웃</li>
          <li @click="withdrawMember" class="no-arrow">{{ memberGb === '01' ? '회원 탈퇴 요청' : '회원 탈퇴' }}</li>
        </ul>
      </div>

      <v-btn v-if="!isSamsungFire" text absolute bottom right class="px-0" style="right: 15px; bottom: 62px;" @click="openWhoyouKakao">
        <v-img :src="getImage('btn_kakao_question_sm.png')" />
      </v-btn>

      <TermsSheet :sheet="sheet" @sheetClose="sheetClose" @termsDetailsOpen="termsDetailsOpen"/>
      <TermsDetailsModal :dialog="termsDetailsDialog" :flag="termsFlag" @close="termsDetailsDialog = false"/>
      <WithdrawalSheet ref="withdrawal" :sheet="WithdrawalFlag" @sheetClose="WithdrawalFlag = false"
                       @rollerPickerOpen="rollerPickerOpen"/>
      <SelectRollerPicker ref="rollerPicker" @selectValue="selectValue"/>
      <urgentConsultationSheet :sheet="urgentConsultationFlag" @sheetClose="urgentConsultationFlag = false"/>
    </v-container>
    <!-- 코치 마크 -->
    <CoachMark @close="isShowCoachMark = false" v-if="isShowCoachMark" />
  </v-main>
</template>
<script>
import store from "@/store"
import { mixinAuth } from "@/mixins"
import WithdrawalSheet from "@/components/layout/bottomSheet/WithdrawalSheet"
import TermsSheet from "@/components/layout/bottomSheet/TermsSheet";
import TermsDetailsModal from "@/components/terms/TermsDetailsModal";
import SelectRollerPicker from "@/components/layout/bottomSheet/SelectRollerPicker";
import urgentConsultationSheet from "@/components/layout/bottomSheet/urgentConsultationSheet";

let popup;
export default {
  components: {
    TermsSheet,
    TermsDetailsModal,
    WithdrawalSheet,
    SelectRollerPicker,
    urgentConsultationSheet,
    CoachMark: () => import('@/page/coachMark/CoachMark.vue')
  },
  mixins: [mixinAuth],
  data: () => ({
    isShowCoachMark: false,
    sheet: false,
    WithdrawalFlag: false,
    termsDetailsDialog: false,
    termsFlag: null,
    items: ['단순변심1', '단순변심2', '단순변심3'],
    urgentConsultationFlag: false
  }),
  created() {
  },
  mounted() {
    if (this.isSamsungFire) {
      this.initAnyfitPro();
    }
 },
  computed: {
    getKakaoChatUrl () {
      //return "http://pf.kakao.com/_Pnxixfxj/chat"
      return 'https://bizmessage.kakao.com/chat/open/@이지앤웰니스';
    },
    getWhoyouChatUrl () {
      return 'https://pf.kakao.com/_Pnxixfxj/chat';
      // return 'https://bizmessage.kakao.com/chat/open/@whoyou';
    }
  },
  methods: {
    urgentConsultationOpen() {
      this.urgentConsultationFlag = true
    },
    initAnyfitPro() {
      let anyfitproScript = document.createElement('script')
      anyfitproScript.setAttribute('src', 'https://anyfitpro.samsungfire.com/apps/common/js/anyfit_appinterface_min.js')
      document.head.appendChild(anyfitproScript)
    },
    next() {
      /* 약관 시트 */
      this.sheet = true;
    },
    sheetClose() {
      this.sheet = false;
    },
    termsDetailsOpen(index) {
      this.termsFlag = index;
      this.termsDetailsDialog = true;
    },
    logout() {
      store.dispatch('logout')
    },
    WithdrawalFlagOpen() {
      this.WithdrawalFlag = true;
    },
    rollerPickerOpen() {
      this.WithdrawalFlag = true
      this.$refs.rollerPicker.setFlicking(this.items);
    },
    selectValue(value) {
      this.$refs.withdrawal.selectValue(value);
    },
    openHappymint(){
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf('android') >= 0) {
        window.AndroidInterface.openHappymint(this.clientCd)
      } else {
        window.webkit.messageHandlers.openHappymint.postMessage(this.clientCd)
      }
    },
    openWhoyouKakao() {
      if (popup) {
        popup.close()
      }
      popup = window.open(this.getWhoyouChatUrl)
    },
    openSfKakao() {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf('android') >= 0) {
        window.anyfitJs.executeExternalBrowser(this.getKakaoChatUrl)
      } else {
        if (popup) {
          popup.close()
        }
        popup = window.open(this.getKakaoChatUrl)
      }
    },
    withdrawMember() {
      if (this.memberInfo.atvtYn === '06') {
        this.$alert('이미 회원 탈퇴 요청이 접수되었습니다.')
        return
      }
      this.movePage('/fo/leave')
    }
  }
}
</script>
